import React from "react";
import { useFilters } from "./FilterContext";
// import colornames from "colornames"; // Uncomment when color swatches are enabled

// const COLOR_OVERRIDES = {
//   multicolor: 'linear-gradient(135deg,#e63946,#fdd835,#4caf50,#2196f3,#9c27b0)',
//   multi: 'linear-gradient(135deg,#e63946,#fdd835,#4caf50,#2196f3,#9c27b0)',
//   natural: '#d4c5a9',
//   neutral: '#c8bfb0',
//   bright: '#ffeb3b',
//   'off white': '#faf9f6',
//   'off-white': '#faf9f6',
//   red: '#e63946',
//   pink: '#f48fb1',
//   orange: '#f4842d',
//   yellow: '#fdd835',
//   green: '#4caf50',
//   blue: '#2196f3',
//   purple: '#9c27b0',
//   black: '#212121',
//   white: '#ffffff',
//   grey: '#9e9e9e',
//   gray: '#9e9e9e',
//   silver: '#c0c0c0',
//   brown: '#795548',
//   navy: '#001f5b',
//   teal: '#009688',
//   gold: '#ffd700',
//   beige: '#f5f5dc',
//   cream: '#fffdd0',
//   coral: '#ff6b6b',
//   sage: '#b2ac88',
//   lavender: '#e6e6fa',
// };

// const hashColor = (name) => {
//   let hash = 0;
//   for (let i = 0; i < name.length; i++) {
//     hash = name.charCodeAt(i) + ((hash << 5) - hash);
//   }
//   return `hsl(${Math.abs(hash) % 360}, 60%, 55%)`;
// };

// const getColorStyle = (name) => {
//   const key = String(name).trim().toLowerCase();
//   if (COLOR_OVERRIDES[key]) {
//     const val = COLOR_OVERRIDES[key];
//     return val.startsWith('linear-gradient') ? { backgroundImage: val } : { background: val };
//   }
//   const hex = colornames(key);
//   if (hex) return { background: hex };
//   return { background: hashColor(key) };
// };

const SubCategory = ({ sub }) => {
  const { filters, pendingFilters, handleFilterChange, openSubcategories, toggleSubcategory, isPendingActive, loader } = useFilters();

  const toKey = (s) => String(s ?? '').trim().toLowerCase();

  const isChecked = (option) => {
    const key = toKey(option.label ?? option.value);
    if (isPendingActive) {
      return pendingFilters[sub.key]?.some(f => toKey(f.label ?? f.value) === key) || false;
    }
    return filters[sub.key]?.some(f => toKey(f.label ?? f.value) === key) || false;
  };

  const uniqueOptions = React.useMemo(() => {
    const seen = new Set();
    const makeKey = (opt) => toKey(opt?.id ?? (opt?.label ?? opt?.value));
    return (sub.options || []).filter(opt => {
      const k = makeKey(opt);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }, [sub.options]);

  // const isColorSection = sub.label?.toLowerCase() === 'color'; // Uncomment when color swatches are enabled

  return (
    <div className="subcategory">
      <h3
        onClick={() => toggleSubcategory(sub.key)}
        style={{ cursor: "pointer" }}
      >
        {sub.label}
        <span>{openSubcategories[sub.key]
          ? <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.99805H0V-0.00195312H14V1.99805Z" fill="black"/></svg>
          : <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 7.99805H8V13.998H6V7.99805H0V5.99805H6V-0.00195312H8V5.99805H14V7.99805Z" fill="black"/></svg>}
        </span>
      </h3>

      {openSubcategories[sub.key] && (
        // Color swatch render — uncomment block below and remove plain checkbox block when client provides color codes
        // isColorSection ? (
        //   <div className="filter_section color_swatch_section" style={{ marginLeft: "8px" }}>
        //     {uniqueOptions.map(option => {
        //       const checked = isChecked(option);
        //       return (
        //         <button
        //           key={`${sub.key}-${option.id ?? (option.label ?? option.value)}`}
        //           className={`color_swatch_btn${checked ? ' active' : ''}`}
        //           title={option.value}
        //           disabled={loader}
        //           onClick={() => handleFilterChange(sub.key, option)}
        //         >
        //           <span className="color_swatch_circle" style={getColorStyle(option.value)} />
        //           <span className="color_swatch_label">{option.value}</span>
        //         </button>
        //       );
        //     })}
        //   </div>
        // ) :
        <div className="filter_section" style={{ marginLeft: "8px" }}>
          {uniqueOptions.map(option => {
            const checked = isChecked(option);
            return (
              <label key={`${sub.key}-${option.id ?? (option.label ?? option.value)}`} className={checked ? "active" : ""}>
                <input
                  type="checkbox"
                  checked={isChecked(option)}
                  onChange={() => handleFilterChange(sub.key, option)}
                  disabled={loader}
                />
                {option.value}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SubCategory;
